import SmileIndex from "src/pages_/smile/index";

export default SmileIndex;
